<template>
  <article>
    <v-card height="100%">
      <v-card-title>
        <div class="subheading grey--text">{{ sliType }} SLI</div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap justify-space-around>
          <v-flex xs12 md6>
            <div class="caption grey--text">Source URL</div>
            <code>{{ sli.sourceURL }}</code>
          </v-flex>
          <v-flex xs12 md6>
            <div class="caption grey--text">Prometheus Query</div>
            <code>{{ sli.query }}</code>
          </v-flex>
        </v-layout>

        <br>
        <h3 class="subheading">Recent Data</h3>
        <br>
        
        <v-layout row wrap>
          <v-flex class="caption grey--text" xs3>
            Timestamp
          </v-flex>
          
          <v-flex class="caption grey--text" xs6>
            Query / Tags
          </v-flex>

          <v-flex class="caption grey--text" xs3>
            Value
          </v-flex>
        </v-layout>

        <v-layout v-for="(metric, idx) of sli.metrics" :key="idx" row wrap>
          <v-flex xs3>
            <code>{{ metric.time }}</code>
          </v-flex>
          <v-flex xs6>
            <kbd>{{ queryAndTags(metric) }}</kbd>
          </v-flex>
          <v-flex xs3>
            <kbd>{{ metric.value }}</kbd>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </article>
</template>

<script>
export default {
  name: "SLIDetail",
  props: {
    sli: {
      type: Object,
      required: true
    },
    sliType: {
      type: String,
      required: true
    }
  },
  methods: {
    queryAndTags(metric) {
      let tags = metric.tags.map((tag) => {
        return `${tag.key}="${tag.value}"`;
      }).join(" ");

      return `${metric.name}{${tags}}`;
    }
  }
};
</script>
